var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2501 10.9999C19.2501 11.1822 19.1776 11.3571 19.0487 11.486C18.9198 11.615 18.7449 11.6874 18.5626 11.6874H5.09701L10.1115 16.701C10.1753 16.7649 10.226 16.8407 10.2606 16.9242C10.2951 17.0076 10.3129 17.0971 10.3129 17.1874C10.3129 17.2777 10.2951 17.3672 10.2606 17.4506C10.226 17.5341 10.1753 17.6099 10.1115 17.6738C10.0476 17.7377 9.97175 17.7883 9.88829 17.8229C9.80484 17.8575 9.71539 17.8753 9.62505 17.8753C9.53472 17.8753 9.44527 17.8575 9.36181 17.8229C9.27835 17.7883 9.20252 17.7377 9.13865 17.6738L2.95115 11.4863C2.88722 11.4225 2.83652 11.3466 2.80192 11.2632C2.76732 11.1797 2.74951 11.0902 2.74951 10.9999C2.74951 10.9095 2.76732 10.8201 2.80192 10.7366C2.83652 10.6532 2.88722 10.5773 2.95115 10.5135L9.13865 4.32599C9.26765 4.19698 9.44262 4.12451 9.62505 4.12451C9.80749 4.12451 9.98246 4.19698 10.1115 4.32599C10.2405 4.45499 10.3129 4.62996 10.3129 4.81239C10.3129 4.99483 10.2405 5.1698 10.1115 5.2988L5.09701 10.3124H18.5626C18.7449 10.3124 18.9198 10.3848 19.0487 10.5138C19.1776 10.6427 19.2501 10.8176 19.2501 10.9999Z",
    fill: "#03154D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.9b084815aaabc1d6cf9f3c06ae3523bf.svg";
export { ForwardRef as ReactComponent };